import React, { FC, memo, PropsWithChildren } from 'react';
import { DivTitleWrapper, DivTitle, FontAwesomeIconStyled, DivContent, DivDescription, DivSection } from '../../styles';
import { ErrorCode } from '../../constants';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { getErrorText } from '../../utils';

type TProps = {
  errorCode: ErrorCode;
  count?: number;
};

const SectionLayout: FC<PropsWithChildren<TProps>> = ({ errorCode, count = 0, children }) => (
  <DivSection>
    <DivTitleWrapper>
      <DivTitle>
        <FontAwesomeIconStyled icon={faExclamationTriangle} />
        {getErrorText(errorCode, count).title}
      </DivTitle>
    </DivTitleWrapper>
    <DivContent>
      <DivDescription>{getErrorText(errorCode, count).description}</DivDescription>
      {children}
    </DivContent>
  </DivSection>
);

export default memo(SectionLayout);
